import { HospitalInfoMapper } from "@/data/mapper/hospital-info-mapper";
import { AddHospitalRequestPayload } from "@/data/payload/admin/add-hospital-request-payload";
import { DeleteHospitalRequestPayload } from "@/data/payload/admin/delete-hospital-request-payload";
import { HospitalInfoRequestPayload } from "@/data/payload/hospital-info-request-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { HospitalSource } from "@/data/source/hospital-source";
import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class HospitalRepositoryImpl implements HospitalRepository {
  constructor(private readonly hospitalSource: HospitalSource) {}

  async getHospitalInfo(
    payload: HospitalInfoRequestPayload,
  ): Promise<SATResult<HospitalInfoEntity, SATError>> {
    const result = await this.hospitalSource.getHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      HospitalInfoMapper.toEntity,
      "HospitalRepositoryImpl::getHospitalInfo",
    );
  }

  async addHospitalInfo(payload: AddHospitalRequestPayload): Promise<SATResult<void, SATError>> {
    const result = await this.hospitalSource.addHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async getHospitalList(): Promise<SATResult<HospitalInfoEntity[], SATError>> {
    const result = await this.hospitalSource.getHospitalList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      HospitalInfoMapper.toEntityList,
      "HospitalRepositoryImpl::getHospitalList",
    );
  }

  async deleteHospitalInfo(
    payload: DeleteHospitalRequestPayload,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.hospitalSource.deleteHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
